import { createSlice } from "@reduxjs/toolkit";

import * as API from "../config/api";
import { ApiRest } from "react-comun-seps/lib/api/ApiRest";
import axios from "axios";
const initialState = {
  listaSolicitudes: {},
  solicitudDetalle: {},
  listaCatalogosGrupo: {},
  listaCatalogosGrupoYCodPadre: {},
  listaTiposIdentificacion: {},
  listaTipoSolicitud: {},
  listaTiposVisa: {},
  listaPaises: [],
  listaProvincias: [],
  listaCantones: [],
  listaParroquias: [],
  tratamientoDatos: {},
  nombres: {},
  persona: {},
  correo: {},
  correoVerificado: {},
  messageSuccess: "",
  messageError: "",
  validarDenominacion: {},
  croquis: {},
};

export const reservaSlice = createSlice({
  name: "reservaSlice",
  initialState,
  reducers: {
    setSolicitudes: (state, action) => {
      state.listaSolicitudes = action.payload;
    },
    setListaCatalogosGrupo: (state, action) => {
      state.listaCatalogosGrupo = action.payload;
    },
    setTipoIdentificacion: (state, action) => {
      state.listaTiposIdentificacion = action.payload;
    },
    setTratamientoDatos: (state, action) => {
      state.tratamientoDatos = action.payload;
    },
    setCorreo: (state, action) => {
      state.correo = action.payload;
    },
    setCorreoVerificado: (state, action) => {
      state.correoVerificado = action.payload;
    },
    setListaCatalogosGrupoYCodPadre: (state, action) => {
      state.listaCatalogosGrupoYCodPadre = action.payload;
    },
    setListaPaises: (state, action) => {
      state.listaPaises = action.payload;
    },
    setListaProvincias: (state, action) => {
      state.listaProvincias = action.payload;
    },
    setListaCantones: (state, action) => {
      state.listaCantones = action.payload;
    },
    setListaParroquias: (state, action) => {
      state.listaParroquias = action.payload;
    },
    setNombres: (state, action) => {
      state.nombres = action.payload;
    },
    setPersona: (state, action) => {
      state.persona = action.payload;
    },
    setMessageSuccess: (state, action) => {
      state.messageSuccess = action.payload;
    },
    setMessageError: (state, action) => {
      state.messageError = action.payload;
    },
    setValidarDenominacion: (state, action) => {
      state.validarDenominacion = action.payload;
    },
    setSolicitudDetalle: (state, action) => {
      state.solicitudDetalle = action.payload;
    },
    setCroquis: (state, action) => {
      state.croquis = action.payload;
    },
    setTipoSolicitud: (state, action) => {
      state.listaTipoSolicitud = action.payload;
    },
    setListaTiposVisa: (state, action) => {
      state.listaTiposVisa = action.payload;
    },
  },
});

export const {
  setSolicitudes,
  setMessageSuccess,
  setMessageError,
  setTipoIdentificacion,
  setListaCatalogosGrupo,
  setListaCatalogosGrupoYCodPadre,
  setListaPaises,
  setListaProvincias,
  setListaCantones,
  setListaParroquias,
  setNombres,
  setPersona,
  setTratamientoDatos,
  setCorreo,
  setCorreoVerificado,
  setValidarDenominacion,
  setSolicitudDetalle,
  setCroquis,
  setTipoSolicitud,
  setListaTiposVisa,
} = reservaSlice.actions;

export const obtenerSolicitudes = (tipoIdentificacion, numIdentificacion) => async (dispatch) => {
  try {
    const result = await ApiRest.get(
      `${API.URL_GET_SOLICITUDES}?idCatTipoIdentificacion=${tipoIdentificacion}&identificacion=${numIdentificacion}`
    );
    dispatch(setSolicitudes(result.data));
  } catch (ex) {
    handleException(ex, dispatch);
  }
};

export const obtenerSolicitudDetalle = (idSolReservaDenominacion) => async (dispatch) => {
  try {
    const result = await ApiRest.get(
      `${API.URL_GET_SOLICITUD_DETALLE}?idSolReservaDenominacion=${idSolReservaDenominacion}`
    );
    dispatch(setSolicitudDetalle(result.data));
  } catch (ex) {
    handleException(ex, dispatch);
  }
};

export const obtenerTiposIdentificacion = () => async (dispatch) => {
  try {
    const result = await ApiRest.get(
      `${API.URL_GET_TIPOS_IDENTIFICACION}?nemGrupo=TIPO_IDENTIFICACION`
    );
    dispatch(setTipoIdentificacion(result.data));
  } catch (ex) {
    handleException(ex, dispatch);
  }
};

export const obtenerTiposVisa = () => async (dispatch) => {
  try {
    const result = await ApiRest.get(`${API.URL_GET_CATALOGOS_GRUPO}?nemGrupo=TIPOVISA`);
    dispatch(setListaTiposVisa(result.data));
  } catch (ex) {
    handleException(ex, dispatch);
  }
};

export const obtenerTiposSolicitud = () => async (dispatch) => {
  try {
    const result = await ApiRest.get(`${API.URL_GET_TIPOS_IDENTIFICACION}?nemGrupo=TIPO_SOLICITUD`);
    dispatch(setTipoSolicitud(result.data));
  } catch (ex) {
    handleException(ex, dispatch);
  }
};

export const obtenerCatalogosPorNemGrupo = (nemGrupo) => async (dispatch) => {
  try {
    const result = await ApiRest.get(`${API.URL_GET_CATALOGOS_GRUPO}?nemGrupo=${nemGrupo}`);
    dispatch(setListaCatalogosGrupo(result.data));
  } catch (ex) {
    handleException(ex, dispatch);
  }
};

export const obtenerCatalogosPorNemGrupoYCodPadre = (nemGrupo, codPadre) => async (dispatch) => {
  try {
    const result = await ApiRest.get(
      `${API.URL_GET_CATALOGOS_GRUPO_COD_PADRE}?nemGrupo=${nemGrupo}&codCatPadre=${codPadre}`
    );
    dispatch(setListaCatalogosGrupoYCodPadre(result.data));
  } catch (ex) {
    handleException(ex, dispatch);
  }
};

export const obtenerPaises = () => async (dispatch) => {
  try {
    const result = await ApiRest.get(`${API.URL_GET_PAIS}`);
    dispatch(setListaPaises(result.data));
  } catch (ex) {
    handleException(ex, dispatch);
  }
};

export const obtenerProvincias = () => async (dispatch) => {
  try {
    const result = await ApiRest.get(`${API.URL_GET_PROVINCIAS}`);
    dispatch(setListaProvincias(result.data));
  } catch (ex) {
    handleException(ex, dispatch);
  }
};

export const obtenerCantones = (codigo) => async (dispatch) => {
  try {
    const result = await ApiRest.get(`${API.URL_GET_CANTONES}?codigo-provincia=${codigo}`);
    dispatch(setListaCantones(result.data));
  } catch (ex) {
    handleException(ex, dispatch);
  }
};

export const obtenerParroquias = (codigo) => async (dispatch) => {
  try {
    const result = await ApiRest.get(`${API.URL_GET_PARROQUIAS}?codigo-canton=${codigo}`);
    dispatch(setListaParroquias(result.data));
  } catch (ex) {
    handleException(ex, dispatch);
  }
};

export const obtenerNombres = (identificacion) => async (dispatch) => {
  try {
    const result = await ApiRest.get(`${API.URL_GET_NOMBRES}?identificacion=${identificacion}`);
    dispatch(setNombres(result.data));
  } catch (ex) {
    handleException(ex, dispatch);
  }
};

export const validarPersona = (data) => async (dispatch) => {
  try {
    const result = await ApiRest.post(`${API.URL_POST_PERSONA}`, data);
    dispatch(setPersona(result.data));
  } catch (ex) {
    handleException(ex, dispatch);
  }
};

export const obtenerTratamientoDatos = (data) => async (dispatch) => {
  try {
    const result = await ApiRest.post(`${API.URL_GET_TRATAMIENTO_DATOS}`, data);
    dispatch(setTratamientoDatos({ object: result.data, code: 200 }));
  } catch (ex) {
    //dispatch(setTratamientoDatos(data));
    handleException(ex, dispatch);
  }
};

export const enviarCorreo = (data) => async (dispatch) => {
  try {
    const result = await ApiRest.post(`${API.URL_POST_ENVIAR_CORREO}`, data);
    dispatch(setCorreo(result.data));
  } catch (ex) {
    handleException(ex, dispatch);
  }
};

export const verificarCorreo = (data) => async (dispatch) => {
  try {
    const result = await ApiRest.post(`${API.URL_POST_VERIFICAR_CORREO}`, data);
    dispatch(setCorreoVerificado(result.data));
  } catch (ex) {
    handleException(ex, dispatch);
  }
};

export const validarDenominacion = (data) => async (dispatch) => {
  try {
    const result = await ApiRest.post(`${API.URL_POST_VALIDAR_DENOMINACION}`, data);
    dispatch(setValidarDenominacion(result.data));
  } catch (ex) {
    handleException(ex, dispatch);
  }
};

export const enviarReserva = (data) => async (dispatch) => {
  try {
    const requestOptions = {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    };
    const result = await axios.post(`${API.URL_POST_ENVIAR_RESERVA}`, data, requestOptions);
    dispatch(setMessageSuccess(result.data.message));
  } catch (ex) {
    handleException(ex, dispatch);
  }
};

export const descargarCroquisPorSolicitud = (codSolictud) => async (dispatch) => {
  try {
    const result = await ApiRest.get(`${API.URL_GET_CROQUIS}?idSolicitud=${codSolictud}`);
    dispatch(setCroquis(result.data));
  } catch (ex) {
    handleException(ex, dispatch);
  }
};

export const validarReservaExistente = (data) => async (dispatch) => {
  try {
    const result = await ApiRest.post(`${API.URL_VALIDATE_RESERVA}`, data);
    dispatch(setSolicitudDetalle(result.data));
  } catch (ex) {
    handleException(ex, dispatch);
  }
};

function handleException(exception, dispatch) {
  if (typeof exception === "string") {
    dispatch(setMessageError(exception));
  } else {
    dispatch(setMessageError(exception.data?.message || exception.data));
  }
}

export default reservaSlice.reducer;
